const AccountPaths = {
    AccountMain: "/Account"
}
export default AccountPaths